import(/* webpackMode: "eager", webpackExports: ["HeaderMain"] */ "/home/runner/work/marketplace/marketplace/apps/web/src/components/header/header-main.tsx");
